// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Risk Assessment",
    titleHelp: "Optional heading to display above the risk assessment",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showAdjustments: "Show adjustment questions",
    showAdjustmentsHelp:
      "Show how the risk score was derived: the client's answers to the risk model's adjustment questions, the initial score, the applied adjustment and any cap.",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Risikovurdering",
    titleHelp: "Valgfri overskrift som vises over risikovurderingen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showAdjustments: "Vis justeringsspørsmål",
    showAdjustmentsHelp:
      "Vis hvordan risikoscoren ble utledet: kundens svar på risikomodellens justeringsspørsmål, utgangspunktet, justeringen som ble brukt og et eventuelt tak.",
  },
} as const;
